import { supabase } from './supabase.client'

interface UserPermissions {
  hasAccess: boolean
}

export class AuthService {
  static async getSession() {
    try {
      const { data: { session }, error } = await supabase.auth.getSession()
      if (error) throw error
      return session
    } catch (error) {
      console.error('Error getting session:', error)
      return null
    }
  }

  static async checkPermissions(userId: string): Promise<UserPermissions> {
    try {
      const { data: userSchools, error } = await supabase
        .from('user_schools')
        .select('school_id')
        .eq('user_id', userId)
        .eq('is_active', true)
        .limit(1)

      if (error || !userSchools || userSchools.length === 0) {
        return { hasAccess: false }
      }

      return { hasAccess: true }
    } catch (error) {
      console.error('Error checking permissions:', error)
      return { hasAccess: false }
    }
  }

  static async getUserProfile(userId: string) {
    try {
      const { data, error } = await supabase
        .from('users')
        .select('id, email, full_name, avatar_url')
        .eq('id', userId)
        .single()

      if (error) throw error
      return data
    } catch (error) {
      console.error('Error fetching user profile:', error)
      return null
    }
  }

  static async signOut() {
    try {
      const { error } = await supabase.auth.signOut()
      if (error) throw error
      window.location.href = '/login'
    } catch (error) {
      console.error('Error signing out:', error)
      window.location.href = '/login'
    }
  }
}
